import { User } from "../users";
import { ForgeAgent } from "./agent";
import { z } from "zod";
export const ForgeParticipant = z.object({
    id: z.string(),
    agentId: z.string().optional(),
    agent: ForgeAgent.optional(),
    projectIterationId: z.string(),
    role: z.enum(["Editor", "Viewer"]),
    type: z.enum(["Agent", "User"]),
    userId: z.string().optional(),
    user: User.optional(),
});
